// extracted by mini-css-extract-plugin
export default {"productDescription":"cba-z","featuredDescription":"dba-z","description":"eba-z","more":"fba-z","descriptionSku":"gba-z"};